import { render, staticRenderFns } from "./x-LaoLongQiaoZhaQianKanBan.vue?vue&type=template&id=1ed32330&scoped=true"
import script from "./x-LaoLongQiaoZhaQianKanBan.vue?vue&type=script&lang=js"
export * from "./x-LaoLongQiaoZhaQianKanBan.vue?vue&type=script&lang=js"
import style0 from "./x-LaoLongQiaoZhaQianKanBan.vue?vue&type=style&index=0&id=1ed32330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed32330",
  null
  
)

export default component.exports